<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="imapHostLocale"
          dense
          outlined
          label="Servidor de e-mail IMAP"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 100) || 'Máximo de 100 caracteres.']"
          @change="v => $emit('update:imapHost', v)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model.number="imapPortLocale"
          type="number"
          min="0"
          max="999"
          dense
          outlined
          label="Porta IMAP"
          validate-on-blur
          :loading="loading"
          :rules="[v => !!v || 'Campo obrigatório']"
          @change="v => $emit('update:imapPort', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="smtpHostLocale"
          dense
          outlined
          label="Servidor de e-mail SMTP"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 100) || 'Máximo de 100 caracteres.']"
          @change="v => $emit('update:smtpHost', v)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model.number="smtpPortLocale"
          type="number"
          min="0"
          max="999"
          dense
          outlined
          label="Porta SMTP"
          validate-on-blur
          :loading="loading"
          :rules="[v => !!v || 'Campo obrigatório']"
          @change="v => $emit('update:smtpPort', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="usernameLocale"
          dense
          outlined
          label="Usuário"
          autocomplete="one-time-code"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, validators.emailValidator, v => (!!v && v.length <= 40) || 'Máximo de 40 caracteres']"
          @change="v => $emit('update:username', v)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="passwordLocale"
          dense
          outlined
          type="password"
          label="Senha"
          autocomplete="one-time-code"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 40) || 'Máximo de 40 caracteres']"
          @change="v => $emit('update:password', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn
          color="error"
          outlined
          @click="handleClickTestarConfigEmail"
        >
          <v-progress-circular
            v-if="isTestarConfigImapSmtpLoading"
            class="mr-3"
            size="20"
            indeterminate
            color="secundary"
          />

          <v-icon
            v-else
            left
          >
            {{ icons.mdiEmail }}
          </v-icon>

          <span>Testar configurações</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import { emailValidator, required } from '@core/utils/validation'
import { mdiEmail } from '@mdi/js'
import EmailService from '@/services/modules/EmailService'

export default {
  emits: ['update:username', 'update:password', 'update:imapHost', 'update:imapPort', 'update:smtpHost', 'update:imapPort'],

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const usernameLocale = ref(null)
    const passwordLocale = ref(null)
    const imapHostLocale = ref(null)
    const imapPortLocale = ref(null)
    const smtpHostLocale = ref(null)
    const smtpPortLocale = ref(null)
    const isTestarConfigImapSmtpLoading = ref(false)

    watch(
      () => props.canalData,
      v => {
        usernameLocale.value = v?.username || null
        passwordLocale.value = v?.password || null
        imapHostLocale.value = v?.imapHost || null
        imapPortLocale.value = v?.imapPort || null
        smtpHostLocale.value = v?.smtpHost || null
        smtpPortLocale.value = v?.smtpPort || null
      },
      { immediate: true, deep: true },
    )

    function getRequestObject() {
      return {
        username: usernameLocale.value,
        password: passwordLocale.value,
        imapPort: imapPortLocale.value,
        imapHost: imapHostLocale.value,
        smtpPort: smtpPortLocale.value,
        smtpHost: smtpHostLocale.value,
      }
    }

    async function handleClickTestarConfigEmail() {
      if (isTestarConfigImapSmtpLoading.value) return

      const request = getRequestObject()

      if (Object.values(request).some(it => !it)) {
        Vue.$toast('Preencha corretamente os campos antes de testar as configurações de e-mail')
        return
      }

      try {
        isTestarConfigImapSmtpLoading.value = true
        const data = await EmailService.testarConfiguracoesImapSmtp(request)

        Vue.$toast.info(data.resultTesteLeituraDeInbox, { timeout: false })
        Vue.$toast.info(data.resultTesteEnvioDeEmail, { timeout: false })
      } finally {
        isTestarConfigImapSmtpLoading.value = false
      }
    }

    return {
      usernameLocale,
      passwordLocale,
      smtpHostLocale,
      smtpPortLocale,
      imapHostLocale,
      imapPortLocale,
      isTestarConfigImapSmtpLoading,
      handleClickTestarConfigEmail,
      validators: {
        required,
        emailValidator,
      },
      icons: {
        mdiEmail,
      },
    }
  },
}
</script>
